import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCall, MdEmail, MdLocationPin, MdSearch, MdWhatsapp } from "react-icons/md";
import { AiFillWechat } from "react-icons/ai";

export default function ContactUsContent(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}


	

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<div 
				className="MainBodySection bg-secondary"
				style={{
					paddingBottom: "50px",
					paddingTop: "50px"
				}}
			>
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h3
								className="text-center font-semi-bold text-extra"
							>
								We welcome your inquiries about our work at the Foundation for Poverty Alleviation and Development Initiatives (FPADI). 
								<span
									style={{
										display: "block",
										borderBottom: "5px solid var(--extraColor)",
										width: "50px",
										margin: "30px auto",
									}}
								>

								</span>
							</h3>
						</div>

						

						<div className="col-md-12 text-center">
							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									
									window.open('mailto:info@fpadi.org', '_blank')
									
								}}
								className="font-bold text-light"
							>
								<MdEmail
									className="text-extra"
								size={32}/>  info@fpadi.org
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									window.open('tel:+255672281291', '_blank')
								}}
								className="font-bold text-light"
							>
								<MdCall
									className="text-extra"
								size={32}/>  
								+255 754 300767 | +255 620 312445 
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									window.open("https://wa.me/+255754300767", "_blank");
							
								}}
								className="font-bold text-light"
							>
								<MdWhatsapp
									className="text-extra"
								size={32}/> Click to chat with us on WhatsApp
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									window.open("https://wa.me/+255754300767", "_blank");
							
								}}
								className="font-bold text-light"
							>
								<MdLocationPin
									className="text-extra"
								size={32}/>  
								Bahari Beach - Kinondoni Municipality, Dar es Salaam, Tanzania
							</h6>

							
							
						</div>

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}